(function(angular, module) {var TagFormController, findEditableTypes, tagFormComponent;

findEditableTypes = function(tagTypes) {
  var editableTypes, group, i, j, len, len1, ref, tag;
  editableTypes = [];
  for (i = 0, len = tagTypes.length; i < len; i++) {
    group = tagTypes[i];
    ref = group.types;
    for (j = 0, len1 = ref.length; j < len1; j++) {
      tag = ref[j];
      if (tag.editable) {
        editableTypes.push(tag);
      }
    }
  }
  return editableTypes;
};

TagFormController = function($scope, $q, TagService) {
  'ngInject';
  var create, isEditing, ref, revalidateName, update, vm, watchExp;
  vm = this;
  isEditing = ((ref = this.tag) != null ? ref.id : void 0) != null;
  if (!isEditing) {
    this.tag = {};
  }
  watchExp = [
    vm.getSlug, function() {
      return vm.tagTypes;
    }
  ];
  revalidateName = function() {
    var ref1, ref2;
    return (ref1 = vm.form) != null ? (ref2 = ref1.ngForm.name) != null ? ref2.$validate() : void 0 : void 0;
  };
  $scope.$watchGroup(watchExp, revalidateName);
  this.validateName = function(name) {
    return TagService.validateName(vm.getSlug(), name, vm.program, vm.tag)["catch"](function(tag) {
      vm.existing = tag;
      return $q.reject(tag);
    });
  };
  this.getSlug = function() {
    var ref1, ref2;
    if (isEditing) {
      return (ref1 = vm.tag) != null ? ref1.slug : void 0;
    } else if (vm.tagTypes.length === 1) {
      return vm.tagTypes[0].slug;
    } else {
      return (ref2 = vm.form.formData.slug) != null ? ref2.slug : void 0;
    }
  };
  this.save = (function(_this) {
    return function(data) {
      if (isEditing) {
        return update(data);
      } else {
        return create(data);
      }
    };
  })(this);
  this["delete"] = function(data) {
    return TagService["delete"](vm.tag).then(function() {
      vm.onDelete({
        tag: vm.tag
      });
    });
  };
  update = function(data) {
    return TagService.update(vm.tag, data.name, data.description).then(function(tag) {
      angular.extend(vm.tag, tag);
      return vm.onSave({
        tag: vm.tag
      });
    });
  };
  create = function(data) {
    var result;
    result = TagService.create(vm.getSlug(), data.name, data.description, vm.program);
    return result.then(function(tag) {
      return vm.onSave({
        tag: tag
      });
    });
  };
};

tagFormComponent = {
  controller: TagFormController,
  templateUrl: 'tags/tagForm',
  controllerAs: 'tagForm',
  bindings: {
    tag: '=?',
    program: '=',
    tagTypes: '=',
    onDelete: '&',
    onSave: '&',
    onClose: '&'
  }
};

module.component('tagForm', tagFormComponent);
})(angular, angular.module("dybTags"));